import { WithRef } from '../../../types';
import IconBase, { CastProductIconProps, getStrokeWidth } from '../IconBase';

const DEFAULT_PRESET_BACKGROUND = '#7EECFB';

export const CastWorkloadAutoscaler = ({
  ref,
  variant,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastProductIconProps>) => {
  const strokeWidth = getStrokeWidth(props.weight);
  const isPreset = variant === 'preset';
  const fill = isPreset
    ? props.fill ?? DEFAULT_PRESET_BACKGROUND
    : props.fill ?? 'none';

  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      viewBox="0 0 25 27"
      fill="none"
    >
      <>
        <path
          d="M24.2295 18.6685V8.33154C24.2295 7.20265 23.6273 6.15723 22.6474 5.59279L13.6958 0.423335C12.7179 -0.141112 11.5115 -0.141112 10.5337 0.423335L1.58206 5.59279C0.604212 6.15723 0 7.20265 0 8.33154V18.6685C0 19.7974 0.602225 20.8428 1.58206 21.4072L10.5337 26.5767C11.5115 27.1411 12.7179 27.1411 13.6958 26.5767L22.6474 21.4072C23.6253 20.8428 24.2295 19.7974 24.2295 18.6685Z"
          fill={fill}
        />
        <mask
          id="mask0_19891_4282"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="27"
        >
          <path
            d="M24.2295 18.6685V8.33154C24.2295 7.20265 23.6273 6.15723 22.6474 5.59279L13.6958 0.423335C12.7179 -0.141112 11.5115 -0.141112 10.5337 0.423335L1.58206 5.59279C0.604212 6.15723 0 7.20265 0 8.33154V18.6685C0 19.7974 0.602225 20.8428 1.58206 21.4072L10.5337 26.5767C11.5115 27.1411 12.7179 27.1411 13.6958 26.5767L22.6474 21.4072C23.6253 20.8428 24.2295 19.7974 24.2295 18.6685Z"
            strokeWidth={strokeWidth}
            fill={color}
          />
        </mask>
        <g mask="url(#mask0_19891_4282)">
          <path
            d="M18.8824 6.94692H19.3824V6.44692H18.8824V6.94692ZM8.82355 10.5718V11.0718H9.32355V10.5718H8.82355ZM5.11512 20.4108L4.61512 20.4121L4.61641 20.9108H5.11512V20.4108ZM15.1765 16.7859V16.2859H14.6765V16.7859H15.1765ZM2.34685 3.63987C2.14795 3.44831 1.83142 3.45426 1.63987 3.65315C1.44831 3.85205 1.45426 4.16858 1.65315 4.36013L2.34685 3.63987ZM20.6352 23.3419C20.824 23.5434 21.1404 23.5536 21.3419 23.3648C21.5434 23.176 21.5537 22.8596 21.3648 22.6581L20.6352 23.3419ZM12 6.94692V7.44692H18.8824V6.94692V6.44692H12V6.94692ZM18.8824 13.6788H19.3824V6.94692H18.8824H18.3824V13.6788H18.8824ZM8.82355 6.42908H8.32355V10.5718H8.82355H9.32355V6.42908H8.82355ZM4.58825 10.5718V11.0718H8.82355V10.5718V10.0718H4.58825V10.5718ZM12.5294 20.4108V19.9108H5.11512V20.4108V20.9108H12.5294V20.4108ZM5.09778 13.6791L4.59778 13.6804L4.61512 20.4121L5.11512 20.4108L5.61512 20.4095L5.59778 13.6778L5.09778 13.6791ZM15.1765 20.9286H15.6765V16.7859H15.1765H14.6765V20.9286H15.1765ZM19.4118 16.7859V16.2859H15.1765V16.7859V17.2859H19.4118V16.7859ZM18.8824 6.94692L18.5328 6.58945L4.76553 20.0533L5.11512 20.4108L5.46471 20.7682L19.232 7.30439L18.8824 6.94692ZM2 4L1.65315 4.36013L8.4767 10.9319L8.82355 10.5718L9.17039 10.2117L2.34685 3.63987L2 4ZM15.1765 16.7859L14.8117 17.1278L20.6352 23.3419L21 23L21.3648 22.6581L15.5413 16.444L15.1765 16.7859Z"
            strokeWidth={strokeWidth}
            fill={color}
          />
        </g>
      </>
    </IconBase>
  );
};

CastWorkloadAutoscaler.displayName = 'CastWorkloadAutoscaler';
